/**
 * Surcharge label resolution.
 * surchargeKind() is pure (no Vue/store/i18n). The render-layer helpers
 * below go through @/utils/language for translation.
 */
import { t, tParams } from '@/utils/language'

/** dayjs day() index → lowercase english weekday. Locale-safe; NEVER use format('dddd'). 定义在 utils/weekdays.js（纯常量，门店时钟也用） */
export { WEEKDAYS } from '@/utils/weekdays'

/**
 * @param {{ type: 'date'|'weekly', weekDay?: string, group?: string }} resolved
 * @returns {{ kind: 'custom', name: string } | { kind: 'public_holiday' } | { kind: 'weekday', weekDay: string }}
 */
export function surchargeKind({ type, weekDay, group } = {}) {
  if (type === 'date' && group && String(group).trim()) return { kind: 'custom', name: String(group).trim() }
  if (type === 'date') return { kind: 'public_holiday' }
  if (type === 'weekly' && weekDay) return { kind: 'weekday', weekDay }
  return { kind: 'public_holiday' }
}

/** Translate a lowercase english weekday key via the `weekdays` table, falling back to the raw key. */
export function localizedDay(weekDay) {
  return (t('weekdays') || {})[weekDay] || weekDay
}

/** Build the user-facing surcharge label (kiosk/mobile i18n render layer). */
export function surchargeName(resolved) {
  const k = surchargeKind(resolved)
  if (k.kind === 'custom') return k.name
  if (k.kind === 'weekday') return tParams('weekday_surcharge', '{weekDay} surcharge', { weekDay: localizedDay(k.weekDay) })
  return t('public_holiday_surcharge', 'Public holiday surcharge')
}
